import { Component, Injector, ViewChild, ViewEncapsulation, OnInit } from '@angular/core';
const swal = require('sweetalert');
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { LoadingService } from '../../../../util/loader.service';
import { EmpresaService } from '../empresa.service';
import { Empresa } from '../../../../models/empresa';
import { ModalRegistrarContatoComponent } from '../modal-registrar-contato/modal-registrar-contato.component';


@Component({
  selector: 'app-registrar-contato',
  templateUrl: './registrar-contato.component.html',
  styleUrls: ['./registrar-contato.component.scss']
})
export class RegistrarContatoComponent implements OnInit {
  selectCheck;
  rows: Object[];
  selected = [];
  blur = false;
  registroSelecao = [];
  parametroConsulta: string;
  filterState = true;
  public modalRef: BsModalRef;
  page = {
    limit: 10,
    count: 0,
    offset: 0,
    descricao: '',
    id: null,
  };
  mesagensGrid = {
    'emptyMessage': 'Nenhum dado para exibir',
    'totalMessage': 'Total de registros',
    'selectedMessage': 'Selecionado'
  };
  acoesBottoes = true;
  botoesAtivados = false;
  valForm: FormGroup;
  sortDir: string = '';
  sortProp: string = ''
  id: any;
  titulo: string = ''
  empresa:Empresa;
  constructor(public service: EmpresaService, fb: FormBuilder, public loader: LoadingService, private route: ActivatedRoute, private router: Router, private modalService: BsModalService) {

    this.route.queryParams.subscribe(params => {
      const record = JSON.parse(params['data']);
      this.empresa = record;
      this.page.id = this.empresa.id_empresa;
      this.id = this.empresa.id_empresa;
      this.reloadTable();
    });
  }
  reloadTable() {
    this.loader.show("body");
    this.service.obterTodosRegistroDeContato(this.page)
      .subscribe((itens) => {
        this.loader.hide("body");
        this.page.count = itens.count;
        this.rows = itens.rows;
        this.botoesAtivados = true;
      });

  }

  openModal(event) {
    const config: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      animated: true,
      ignoreBackdropClick: true,
      initialState: {
        codigo: this.id
      }
    };
    this.modalRef = this.modalService.show(ModalRegistrarContatoComponent, config);

    this.modalRef.content.onClose.subscribe(result => {
      this.reloadTable();

    });
  }
  linkEdit() {
    if (this.registroSelecao.length > 1) {
      swal('Atenção', 'Selecione apenas um registro.', 'warning');
    } else {
      this.loader.show('body');
      const codigo = this.registroSelecao[0].id_registro_contato;

      this.service.obterPorCodigoRegistroDeContato(codigo)
        .subscribe(itens => {
          this.loader.hide('body');
          const config: ModalOptions = {
            backdrop: 'static',
            keyboard: false,
            animated: true,
            ignoreBackdropClick: true,
            initialState: {
              codigo: this.id,
              record: itens
            }
          };
          this.modalRef = this.modalService.show(ModalRegistrarContatoComponent, config);

          this.modalRef.content.onClose.subscribe(result => {
            this.reloadTable();
            //this.limparSelecionados();
          });
        });
    }
  }
  filtro(event) {
    if (event.keyCode == 13) {
      this.page.descricao = this.parametroConsulta;
      this.page.offset = 0;
      this.reloadTable();
    }
  }

  clearReload() {
    this.page.descricao = "";
    this.parametroConsulta = "";
    this.page.offset = 0;
    this.reloadTable();
  }
  onFilterChange(eve: any) {
    this.limparSelecionados();
    this.reloadTable();
  }

  pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
    this.page.offset = pageInfo.offset;
    this.reloadTable();
  }
  limparSelecionados() {
    this.registroSelecao = [];
    this.selected = [];
    this.acoesBottoes = true;
  }

  marcarCheck(codigo) {
    let x = false;
    this.selected.forEach(item => {
      if (item.codigo == codigo) {
        x = true;
      }
    });
    return x;
  }
  onSelect(event) {
    let itens = event.selected;

    let itensSemduplicacao = itens.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null));

    let itemSerRemovido = this.pegarDiferenca(itens, itensSemduplicacao);
    try {
      itens = this.removerItem(itensSemduplicacao, itemSerRemovido);
    } catch (error) {
      //ignore, tudo certo
    }
    this.selected = itens;
    event.selected = itens;

    if (event.selected.length > 0) {
      this.registroSelecao = event.selected;
      this.acoesBottoes = false;
    } else {
      this.acoesBottoes = true;
    }
  }
  emoveItemDuplicado(array) {
    array.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null))
    return array;
  }

  removerItem(array, item) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].codigo == item[0].codigo) {
        array.splice(i, 1);
      }
    }

    return array;
  }
  onSort(event) {
    this.sortDir = event.sorts[0].dir;
    this.sortProp = event.sorts[0].prop;
    this.page.offset = 0;
    this.reloadTable();
  }
  pegarDiferenca(r1, r2) {
    let r3 = r1.filter(a => !r2.includes(a));
    return (r3);
  }
  ngOnInit() {
  }

}
